import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=0ecf4c68&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=0ecf4c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf4c68",
  null
  
)

export default component.exports